import React, { useEffect, useRef, useState, useContext } from "react"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardHeader,
  Collapse,
} from "reactstrap"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import classnames from "classnames"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getGroupCalendarEvents, getGroupCallClients, getGroupClientConfig } from "helpers/backend_helper"
import {
  stringSorter,
  numberSorter,
  dateSorter,
  defaultPageSizeOptions,
  formatDate,
  showToast,
} from "utils/general"
import { Switch, Table as AntdTable, Input as AntdInput, Select, Space, Tag } from "antd"
import QuickGuide from "components/QuickGuides/QuickGuide"
import GlobalState from "contexts/GlobalState"
import { tableDefaultHeight } from "constants/layout"
import { clientLinksFormatter } from "utils/tables"
import dayjs from "dayjs"
import VideoMessageModal from "./VideoMessageModal"
import GroupFiltersTable from "../GroupFiltersTable"
const { Search } = AntdInput

const GroupCallTest = props => {
  const [state] = useContext(GlobalState)
  const [isProduction, setIsProduction] = useState(true)
  const [hasDemoRoom, setHasDemoRoom] = useState(false)
  const [activeTab, setActiveTab] = useState("1")
  const [quickGuide, setQuickGuide] = useState(false)
  const [guestsLoading, setGuestsLoading] = useState(false)
  const [callLoading, setCallLoading] = useState(false)
  const [clients, setClients] = useState([])
  const [filteredClients, setFilteredClients] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [selectedClients, setSelectedClients] = useState([])
  const [selectedClient, setSelectedClient] = useState()
  const [messageModal, setMessageModal] = useState(false)

  const [groupSessionTitle, setGroupSessionTitle] = useState("")
  const [quickSelect, setQuickSelect] = useState()

  const [clientTagOptions, setClientTagOptions] = useState([])
  const [clientTagFilter, setClientTagFilter] = useState([])
  const [searchText, setSearchText] = useState("")
  const [customFilter, setCustomFilter] = useState([])

  const [showEvents, setShowEvents] = useState(false)
  const [eventsLoading, setEventsLoading] = useState(false)
  const [events, setEvents] = useState([])

  const abortRef = useRef(null)
  useEffect(() => {
    document.title = props.t("Group video calls") + " | Suvanto Care"
    abortRef.current = new AbortController()
    if (state.authUser != null) {
      const obj = JSON.parse(state.authUser)
      if (
        obj.groupVideoId &&
        obj.groupVideoId.length > 0 &&
        obj.groupVideoDemoId &&
        obj.groupVideoDemoId.length > 0
      ) {
        setHasDemoRoom(true)
      }

      if (obj.features?.group_call_extras) {
        setShowEvents(true)
      }
    }
    return () => abortRef.current.abort()
  }, [])

  useEffect(() => {
    getGroupClients()
    getGroupEvents()
  }, [isProduction])

  // Search or filter changed
  useEffect(() => {
    handleSearch()
  }, [
    clients,
    searchText,
    clientTagFilter,
    customFilter,
  ])

  useEffect(() => {
    if (quickSelect && clients?.length > 0) {
      let keys = []
      let filtered = clients.filter(
        data =>
          (data.client_tags?.some(tag => tag == quickSelect))
      )
      for (const element of filtered) {
        keys.push(element.key)
      }
      setSelectedRowKeys(keys)
    }
    else {
      setSelectedRowKeys([])
    }
  }, [quickSelect])

  useEffect(() => {
    if (selectedRowKeys?.length > 0) {
      let array = []
      let filtered = clients.filter(
        data =>
          (selectedRowKeys?.includes(data.key))
      )
      for (const element of filtered) {
        array.push({ "name": element.name, "key": element.key, "status": element.status })
      }
      setSelectedClients(array)
    }
    else {
      setSelectedClients([])
    }

  }, [selectedRowKeys])

  // Handle search function
  const handleSearch = () => {
    let searchTextLowercase = searchText.toLowerCase()
    let result = clients.filter(
      data =>
        (clientTagFilter?.length == 0 || data.client_tags?.some(tag => clientTagFilter.includes(tag))) &&
        (customFilter?.length == 0 || customFilter?.includes(data.key)) &&
        (data.name?.toLowerCase().includes(searchTextLowercase) || data.group?.toLowerCase().includes(searchTextLowercase))
    )
    setFilteredClients(result)
  }

  // Get list of group guests
  const getGroupClients = () => {
    setGuestsLoading(true)
    getGroupCallClients(abortRef.current, !isProduction)
      .then(result => {
        if (result.clients) {

          result.clients.sort(function (a, b) {
            return a.name.localeCompare(b.name)
          })

          result.clients.sort(function (a, b) {
            return b.status.localeCompare(a.status)
          })

          let foundTags = []
          for (const element of result.clients) {
            element.links = [{ "name": element.name, "key": element.key }]
            element.client_tags_string = element.client_tags.join(", ")

            if (element.client_tags?.length > 0) {
              for (const tag of element.client_tags) {
                if (!foundTags.includes(tag)) {
                  foundTags.push(tag)
                }
              }
            }
          }
          setClients(result.clients)

          // Client tags grouping
          foundTags.sort(function (a, b) {
            return a.localeCompare(b)
          })

          let tagOpts = []
          for (const element of foundTags) {
            if (element.indexOf(" > ") > 0) {
              let split = element.split(" > ")

              let parent = tagOpts.find(i => i.title == split[0])
              if (parent) {
                parent.options.push({
                  label: split[1], value: element
                })
              }
              else {

                let tag = new Object();
                tag.label = split[0];
                tag.title = split[0];
                tag.options = [{
                  label: split[1], value: element
                }];
                tagOpts.push(tag)
              }
            }
            else {
              let tag = new Object();
              tag.label = element;
              tag.value = element;
              tagOpts.push(tag)
              /*let tag = new Object();
              tag.label = props.t("Undefined")
              tag.title = props.t("Undefined")
              tag.options = [{
                label: element, value: element
              }];
              tagOpts.push(tag)*/
            }
          }
          setClientTagOptions(tagOpts)
        }
        setGuestsLoading(false)
      })
      .catch(err => {
        console.log(err)
        setGuestsLoading(false)
      })
  }

  // Get group call events - Suvanto Pro
  const getGroupEvents = () => {
    if (!eventsLoading) {
      setEventsLoading(true)

      let start = dayjs().startOf("month")
      let end = dayjs().endOf("month")

      getGroupCalendarEvents(abortRef.current, start, end, isProduction)
        .then(result => {
          if (result.statusCode == 200 && result.events != null) {
            for (const element of result.events) {
              element.day = dayjs(element.start).format("dddd") + " " + dayjs(element.start).format("D.M.")
              element.time = dayjs(element.start).format("HH:mm") + " - " + dayjs(element.start).add(element.duration, "minutes").format("HH:mm")

              let users = []
              for (const user of element.users) {
                users.push(user.name)
              }
              element.usersString = users.join(", ")

              const currentTime = dayjs()
              element.active = currentTime.isBetween(dayjs(element.start).add(-10, "minutes"), dayjs(element.start).add(element.duration, "minutes"))

            }
            setEvents(result.events)
          }
        })
        .catch(e => {
          console.log(e)
          setEvents([])
        })
        .finally(() => {
          setEventsLoading(false)
        })
    }
  }

  // Start call, get config from server
  const startCall = () => {
    let invites = []
    if (selectedRowKeys?.length > 0) {
      for (const client of clients) {
        if (selectedRowKeys.includes(client.key)) {
          invites.push(client.room)
        }
      }
    }

    if (!callLoading) {
      setCallLoading(true)
      getGroupClientConfig(abortRef.current, !isProduction, invites, undefined, groupSessionTitle)
        .then(result => {
          if (result.statusCode == 200 && result.link != null) {
            globalThis.open(result.link, "_blank", "noreferrer")
          } else if (result.status == "missing_id") {
            showToast(props.t("No group video permissions"), "error")
          } else {
            showToast(props.t("Something went wrong"), "error")
          }
        })
        .catch(e => {
          console.log(e)
          showToast(props.t("Something went wrong"), "error")
        })
        .finally(() => {
          setCallLoading(false)
        })
    }
  }

  // Join event
  const joinEvent = (roomName, title) => {
    if (!callLoading) {
      setCallLoading(true)
      getGroupClientConfig(abortRef.current, !isProduction, [], roomName)
        .then(result => {
          if (result.statusCode == 200 && result.link != null) {
            globalThis.open(result.link, "_blank", "noreferrer")
          } else if (result.status == "missing_id") {
            showToast(props.t("No group video permissions"), "error")
          } else {
            showToast(props.t("Something went wrong"), "error")
          }
        })
        .catch(e => {
          console.log(e)
          showToast(props.t("Something went wrong"), "error")
        })
        .finally(() => {
          setCallLoading(false)
        })
    }
  }

  // Table structure
  const columns = [
    {
      dataIndex: "status",
      title: props.t("Status"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "status", sortOrder)
      },
      render: (cell, row) => {
        switch (cell) {
          case "offline":
            return <>
              <div className="d-inline-grid">
                <span className="text-muted">{props.t("Unavailable")}</span>
                <span className="text-muted font-size-12">{"" + formatDate(row.last_online) + " lähtien"}</span>
              </div>
            </>
          case "online":
            return <>
              <span className="text-success">{props.t("Available")}</span>
            </>
          case "group":
            return <>
              <span className="text-primary">{props.t("In group call")}</span>
            </>
          case "call":
            return <>
              <span className="text-primary">{props.t("In call")}</span>
            </>
          default:
            return <>
              <span className="text-muted">{props.t("Unknown")}</span>
            </>
        }
      },
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "group",
      title: props.t("Group"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "group", sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "name",
      title: props.t("Customer"),
      render: clientLinksFormatter,
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "name", sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "actions",
      title: props.t("Actions"),
      align: "center",
      render: editFormatter,
      fixed: "left",
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "auto_answer",
      title: props.t("Auto answer"),
      align: "center",
      sorter: (a, b) => {
        return a.auto_answer - b.auto_answer
      },
      render: cell => {
        return cell ? (<span className="badge bg-success font-size-12">{props.t("Enabled")}</span>) : <></>
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "device_battery",
      title: props.t("Battery"),
      align: "center",
      sorter: (a, b, sortOrder) => {
        return numberSorter(
          a["device_battery"],
          b["device_battery"],
          sortOrder
        )
      },
      render: cell => {
        return cell ? <span>{cell + "%"}</span> : <></>
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "client_tags_string",
      title: props.t("Client tags"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "client_tags_string", sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    /*{
      dataIndex: "last_online",
      title: props.t("Last online"),
      sorter: (a, b, sortOrder) => {
        return dateSorter(a["last_online"], b["last_online"], sortOrder)
      },
      render: dateFormatter,
      width: "160px",
      ellipsis: true,
    },*/
  ]

  const eventColumns = [
    {
      dataIndex: "start",
      title: props.t("Date"),
      render: eventDateFormatter,
      sorter: (a, b, sortOrder) => {
        return dateSorter(a["start"], b["start"], sortOrder)
      },
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "time",
      title: props.t("Time"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "time", sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "title",
      title: props.t("Title"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "title", sortOrder)
      },
      render: titleFormatter,
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "duration",
      title: props.t("Duration"),
      sorter: (a, b, sortOrder) => {
        return numberSorter(
          a["duration"],
          b["duration"],
          sortOrder
        )
      },
      width: "140px",
      ellipsis: true,
    },
    /*{
      dataIndex: "canceled",
      title: props.t("Canceled"),
      align: "center",
      sorter: (a, b) => {
        return a.canceled - b.canceled
      },
      render: cell => {
        return cell ? <i className="mdi mdi-check-bold text-danger" /> : <></>
      },
      width: "140px",
      ellipsis: true,
    },*/
    {
      dataIndex: "usersString",
      title: props.t("Ilmoittautuneet asiakkaat"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "usersString", sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "actions",
      title: props.t("Actions"),
      align: "center",
      render: eventActionsFormatter,
      fixed: "right",
      width: "100px",
      ellipsis: true,
    },
  ]

  function editFormatter(cell, row) {
    return (
      <div className="d-inline-flex">
        <Button
          color="transprent"
          className="text-primary"
          //outline
          size="sm"
          onClick={() => {
            setSelectedClient(row)
            setMessageModal(true)
          }}
        >
          <i className="mdi mdi-message-text-clock me-2" />
          {props.t("Send a message")}
        </Button>
      </div>
    )
  }

  function titleFormatter(cell, row) {
    return (
      row.canceled ? <span className="text-danger">{cell + " (" + props.t("Event canceled") + ")"}</span> : cell
    )
  }

  function eventActionsFormatter(cell, row) {
    return (
      (!row.canceled && row.active) ?
        <div className="d-inline-flex">
          <Button
            color="secondary"
            size="sm"
            disabled={callLoading}
            onClick={() => {
              joinEvent(row.roomName, row.title)
            }}
          >
            <i className="mdi mdi-video me-2" />
            {props.t("Join")}
          </Button>
        </div> : <></>
    )
  }

  function eventDateFormatter(cell, row) {
    return <span>{row.day}</span>
  }

  // Table selection changed
  // Check for previously selected rows that are filtered out and combine with new selections
  const onSelectChange = (newSelectedRowKeys, newSelectedRows) => {
    const keys = filteredClients.map(obj => obj.key)
    const temp = selectedRowKeys.filter(item => !keys.includes(item))
    const combined = [...new Set([...newSelectedRowKeys, ...temp])];
    setSelectedRowKeys(combined) // newSelectedRowKeys
  }

  return (
    <>
      <div className="page-content">
        <Container fluid={true} className={quickGuide ? "quick-guide-open" : ""}>
          <Breadcrumbs
            title={props.t("Group video calls")}
            className="breadcrumb m-0 justify-content-center"
            breadcrumbItem={
              <>
                {hasDemoRoom && (
                  <div className="d-inline-block mb-0">
                    <div className="d-flex me-1">
                      <Switch
                        name="isProduction"
                        checked={isProduction}
                        onChange={v => setIsProduction(v)}
                        checkedChildren="PROD"
                        unCheckedChildren="DEMO"
                        className={classnames({
                          "switch-colored": isProduction === false,
                        })}
                      />
                    </div>
                  </div>
                )}
                <div className="d-inline-block">
                  <QuickGuide
                    source={"groupVideoCall"}
                    isOpen={quickGuide}
                    setIsOpen={setQuickGuide}
                  />
                </div>
              </>
            }
          />

          <Card>
            {showEvents &&
              <CardHeader className="bg-transparent border-bottom">
                <div className="d-flex flex-wrap">
                  <ul className="nav nav-tabs nav-tabs-custom card-header-tabs">
                    <NavItem>
                      <NavLink
                        to="#"
                        active={activeTab === "1"}
                        onClick={() => {
                          setActiveTab("1")
                        }}
                      >
                        {props.t("Group call")}
                      </NavLink>
                    </NavItem>
                    {showEvents &&
                      <NavItem>
                        <NavLink
                          active={activeTab === "2"}
                          onClick={() => {
                            setActiveTab("2")
                          }}
                        >
                          {props.t("Tulevat tapahtumat") + " (" + events.length + ")"}
                        </NavLink>
                      </NavItem>
                    }
                  </ul>
                </div>
              </CardHeader>
            }
            <CardBody>
              <TabContent activeTab={activeTab}>
                <TabPane className="show" tabId="1">
                  <Collapse isOpen={selectedClients.length > 0}>
                    <div className="mb-2">
                      <span className="h6 text-muted">
                        {selectedClients.length == 1 ? (
                          <>
                            {selectedClients.length + " " + props.t("selected client")}
                          </>
                        ) : (
                          <>
                            {selectedClients.length + " " + props.t("selected clients")}
                          </>
                        )}
                      </span>
                    </div>
                    <Space size={[0, 8]} wrap className="mb-3">
                      {selectedClients.map(user => (
                        <span key={user.key + "_key"}>
                          <Tag
                            style={{ borderRadius: "4px" }}
                            key={user.key + "_tag"}
                            className="py-1 px-2"
                            onClose={() => {
                              setSelectedRowKeys(prevState =>
                                prevState.filter(prevItem => prevItem !== user.key)
                              )
                            }}
                            closable
                          >
                            <div className="d-inline-block">
                              <i
                                className={
                                  "bx bxs-circle me-2 font-size-10 text-" +
                                  classnames({ "success": user.status == "online", "danger": user.status == "offline", "primary": (user.status == "call" || user.status == "group") })
                                }
                              />
                              <span>{user.name}</span>
                            </div>

                          </Tag>
                        </span>
                      ))}
                      <Button
                        onClick={() => {
                          onSelectChange([], [])
                        }}
                        className="me-1"
                        size="sm"
                        color="danger"
                        outline
                      >
                        {props.t("Clear selection")}
                      </Button>
                    </Space>
                  </Collapse>
                  <Row className="mt-1">
                    <Col style={{ maxWidth: "300px" }}>
                      <AntdInput
                        allowClear
                        placeholder={props.t("Title") + " (" + props.t("Optional") + ")"}
                        value={groupSessionTitle}
                        onChange={(v) => { setGroupSessionTitle(v.target.value) }}
                      />
                    </Col>
                    <Col>
                      <Button
                        className="compact-button"
                        disabled={callLoading}
                        onClick={() => startCall()}
                      >
                        <i className="fas fa-video me-2"></i>
                        {props.t("Start group call")}
                      </Button>
                    </Col>
                  </Row>
                  <hr className="mt-4 mb-3" />

                  <h5 className="font-size-15">{props.t("Group call clients")}</h5>
                  <Row className="mb-1 mt-3">
                    <Col className="mb-2" style={{ maxWidth: "320px" }}>
                      <Search
                        placeholder={props.t("Search")}
                        allowClear
                        value={searchText}
                        onChange={event => {
                          setSearchText(event.target.value)
                        }}
                        style={{ minWidth: "240px" }}
                      />
                    </Col>
                    <Col className="mb-2 col-auto" style={{ minWidth: "320px" }}>
                      <Select
                        placeholder={props.t("Client tags")}
                        mode="multiple"
                        allowClear
                        showSearch
                        style={{ width: "100%" }}
                        value={clientTagFilter}
                        onChange={(v) => { setClientTagFilter(v) }}
                        options={clientTagOptions}
                      />
                    </Col>
                    <Col className="col-auto mb-2">
                      <Button
                        className="compact-button"
                        color="primary"
                        disabled={guestsLoading}
                        onClick={() => {
                          if (filteredClients?.length > 0) {
                            let keys = []
                            for (const element of filteredClients) {
                              keys.push(element.key)
                            }
                            setSelectedRowKeys(keys)
                          }
                          else {
                            setSelectedRowKeys([])
                          }
                        }}
                      >
                        {props.t("Valitse näkyvät")}
                      </Button>
                    </Col>
                    <Col className="col-autoo">
                      <Button
                        className="compact-button float-end text-primary"
                        color="transparent"
                        disabled={guestsLoading}
                        onClick={() => {
                          getGroupClients()
                        }}
                      >
                        <i className="mdi mdi-refresh me-2" />
                        {props.t("Refresh")}
                      </Button>
                    </Col>
                  </Row>

                  <GroupFiltersTable
                    groupGuests={clients}
                    t={props.t}
                    setFilterKeys={setCustomFilter}
                  />

                  <Row className="mt-1">
                    <Col xl="12">
                      <AntdTable
                        className="narrow-header"
                        bordered
                        size="small"
                        rowKey={"key"}
                        columns={columns}
                        dataSource={filteredClients}
                        rowSelection={{
                          selectedRowKeys: selectedRowKeys,
                          onChange: onSelectChange,
                          /*getCheckboxProps: record => ({
                            disabled: record.status == "offline",
                          }),*/
                        }}
                        pagination={{
                          showTotal: (total) => `${total} ${props.t("customers")}`,
                          showSizeChanger: true,
                          defaultPageSize: 100,
                          pageSizeOptions: defaultPageSizeOptions,
                        }}
                        loading={guestsLoading}
                        tableLayout="auto"
                        scroll={{
                          x: "max-content",
                          y: tableDefaultHeight,
                        }}
                      />
                    </Col>
                  </Row>
                </TabPane>
                <TabPane className="show" tabId="2">
                  <Row>
                    <Col>
                      <div className="mb-3">
                        <i className="mdi mdi-information-outline me-2 text-primary" />
                        <span>{"Tapahtumaan voi liittyä 10 minuuttia ennen sen alkamisaikaa"}</span>
                      </div>
                    </Col>
                    <Col className="col-autoo">
                      <Button
                        className="compact-button float-end text-primary"
                        color="transparent"
                        disabled={eventsLoading}
                        onClick={() => {
                          getGroupEvents()
                        }}
                      >
                        <i className="mdi mdi-refresh me-2" />
                        {props.t("Refresh")}
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mt-1">
                    <Col xl="12">
                      <AntdTable
                        className="narrow-header"
                        bordered
                        size="small"
                        rowKey={"id"}
                        columns={eventColumns}
                        dataSource={events}
                        pagination={{
                          showTotal: (total) => `${total} ${props.t("events")}`,
                          showSizeChanger: true,
                          defaultPageSize: 100,
                          pageSizeOptions: defaultPageSizeOptions,
                        }}
                        loading={eventsLoading}
                        tableLayout="auto"
                        scroll={{
                          x: "max-content",
                          y: tableDefaultHeight,
                        }}
                      />
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>

          <VideoMessageModal isOpen={messageModal} data={selectedClient} closeModal={setMessageModal} />

        </Container>
      </div>
    </>
  )

}

GroupCallTest.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(GroupCallTest)